import "./BeginYourJourney.module.css";
import Header from "@/reusable_sections/Header";
import LetSCreateMagic from "./sections/LetSCreateMagic";
import FindUs from "./sections/FindUs";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function BeginYourJourneyPage() {
  return <div>
      <Header />
      <LetSCreateMagic />
      <FindUs />
      <CommonInquiries />
      <Footer />
    </div>;
}